import { render, staticRenderFns } from "./DebateRequests.vue?vue&type=template&id=f8c957d0&scoped=true&"
import script from "./DebateRequests.vue?vue&type=script&lang=js&"
export * from "./DebateRequests.vue?vue&type=script&lang=js&"
import style0 from "./DebateRequests.vue?vue&type=style&index=0&id=f8c957d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c957d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
